// 弹出框类
import Jurisdiction from "@/components/Dialog/Jurisdiction/Jurisdiction.vue"; //常用功能弹框
import HeadConfigDialog from "@/components/Dialog/HeadConfigDialog/HeadConfigDialog.vue"; //页面配置弹出框
import addAreaDalog from "@/components/Dialog/addAreaDalog/addAreaDalog.vue"; //新增地区弹出框
import addClerkDialog from "@/components/Dialog/addClerkDialog/addClerkDialog.vue"; //新增经手人弹出框
import addCustomDialog from "@/components/Dialog/addCustomDialog/addCustomDialog.vue"; //新增单位弹出框
import addDalog from "@/components/Dialog/addDalog/addDalog.vue"; //新增仓库弹出框
import manyUnit from "@/components/Dialog/manyUnit/manyUnit.vue"; //新增仓库弹出框
import SearchBankDialog from "@/components/Dialog/SearchBankDialog/SearchBankDialog.vue"; //银行账户列表弹出框
import SearchSubjectDialog from "@/components/Dialog/SearchSubjectDialog/SearchSubjectDialog.vue"; //科目弹出框

import searchClerkDialog from "@/components/Dialog/searchClerkDialog/searchClerkDialog.vue"; //单位、仓库、经手人列表弹出框
import ClassificationDialog from "@/components/Dialog/ClassificationDialog/ClassificationDialog.vue"; //分类弹出框
import TableConfigDialog from "@/components/Dialog/TableConfigDialog/TableConfigDialog.vue"; //单据表格配置弹出框
import SearchGoodsDialog from "@/components/Dialog/SearchGoodsDialog/SearchGoodsDialog.vue"; //单据表格商品选择弹出框
import SearchPriceDialog from "@/components/Dialog/SearchPriceDialog/SearchPriceDialog.vue"; //单据表格价格选择弹出框
import Customerdialog from '@/components/Dialog/Customerdialog/Customerdialog.vue'; // 基础信息 选择客户
import AddMember from '@/components/Dialog/AddMember/AddMember.vue'; // 基础信息 新增职员
import regions from '@/components/Dialog/region/region.vue'; // 基础信息 选择地区
import treebox from '@/components/Dialog/treebox/treebox.vue'; // 基础信息 选择地区
import Searchcontent from '@/components/Dialog/Searchcontent/Searchcontent.vue'; // 基础信息 选择往来单位
import AddStorehouse from '@/components/Dialog/AddStorehouse/AddStorehouse.vue'; // 基础信息 新增仓库
import Warehouse from '@/components/Dialog/Warehouse/Warehouse.vue'; // 基础信息 选择仓库
import authority from "@/components/Dialog/authority/authority.vue"; //岗位权限
import Choosehandler from '@/components/Dialog/Choosehandler/Choosehandler.vue'; // 基础信息 选择经手人
import Customer from '@/components/Dialog/Customer/Customer.vue'; // 选择客户弹框---待命名
import department from "@/components/Dialog/department/department.vue"; // 选择部门  // 不能用
import InvenTory from "@/components/Dialog/InvenTory/InvenTory.vue"; // 盘点单初始化 
import power from '@/components/Dialog/power/power.vue'; // 岗位权限弹框
import Subject from "@/components/Dialog/Subject/Subject.vue"; //选择科目
import ObtainOrder from "@/components/Dialog/ObtainOrder/ObtainOrder.vue"; //调订单弹出框
import ChoiceDialog from "@/components/Dialog/ChoiceDialog/ChoiceDialog.vue"; // 选择框 
import SubjectsDialog from "@/components/Dialog/SubjectsDialog/SubjectsDialog.vue"; // 增加应收表格-科目弹出框
import HeaderElastic from "@/components/Dialog/HeaderElastic/HeaderElastic.vue"; // 表头配置
import IncreaseDialogtable from "@/components/Dialog/IncreaseDialogtable/IncreaseDialogtable.vue"; // 基础新增的分类弹框
import batchDialog from "@/components/Dialog/batchDialog/batchDialog.vue"; // 批次情况  选择批次
import grouping from "@/components/Dialog/grouping/grouping.vue"; // 分组权限

import Searchpop from "@/components/Dialog/Searchpop/Searchpop.vue"; // 弹出选择框
import MaTreeSelect from "@/components/Dialog/MaTreeSelect/MaTreeSelect.vue"; // 弹出框选择树节点分类

import GoodsTables from "@/components/Dialog/GoodsTable/GoodsTable.vue"; // 商品选择框  
import SubjectTables from "@/components/Dialog/SubjectTable/SubjectTable.vue"; // 科目选择框
import UnitPrice from "@/components/Dialog/UnitPrice/UnitPrice.vue"; // 单价选择框
import IncreaseChange from "@/components/Dialog/IncreaseChange/IncreaseChange.vue"; // 基础信息增改弹框
import CompanyDialog from "@/components/Dialog/CompanyDialog/CompanyDialog.vue"; // 单位选择弹框
import SerialTable from "@/components/Dialog/SerialTable/SerialTable.vue"; // 数量选择弹框 
import Multiple from "@/components/Dialog/Multiple/Multiple.vue"; // 数量  多单位
import MultipleRiod from "@/components/Dialog/MultipleRiod/MultipleRiod.vue"; // 期初 数量  多单位
import AddBatchDialog from "@/components/Dialog/AddBatchDialog/AddBatchDialog.vue"; // 期初批次录入
import coloursequence from "@/components/Dialog/coloursequence/coloursequence.vue"; // 期初序列号录入





//input输入框类
import SelectInput from "@/components/Input/SelectInput/SelectInput.vue"; //选择、添加输入框
import SelectInputMultiple from "@/components/Input/SelectInputMultiple/SelectInputMultiple.vue"; // 报表--多选input框
import InputSearch from "@/components/Input/InputSearch/InputSearch.vue"; //只选择输入框
import InputTwo from "@/components/Input/InputTwo/InputTwo.vue"; //日期选择框
import InputThree from "@/components/Input/InputThree/InputThree.vue"; //只输入框
import InputSelect from "@/components/Input/InputSelect/InputSelect.vue"; // 报表--下拉框
import SelectOne from "@/components/Input/SelectOne/SelectOne.vue"; //下拉输入框
import InputReadOne from "@/components/Input/InputReadOne/InputReadOne.vue"; //只可读输入框
import InputRead from "@/components/Input/InputRead/InputRead.vue"; //单据底部只可读输入框
import InputOne from '@/components/Input/InputOne/InputOne.vue'; // 基础信息--输入框
import lowerinput from "@/components/Input/lowerinput/lowerinput.vue"; // 企业信息
import seleck from "@/components/Input/seleck/seleck.vue"; // 设置--日志下拉框
import elasticinput from "@/components/Input/elasticinput/elasticinput.vue"; // 设置--现金银行期初条件查询
import MaInput from "@/components/Input/MaInput/MaInput.vue"; // 可选择输入框
import MaInuptTwo from "@/components/Input/MaInuptTwo/MaInuptTwo.vue"; // 日期输入框  
import MaInputThree from "@/components/Input/MaInputThree/MaInputThree.vue"; // 只可输入框
import Increaseinput from "@/components/Input/IncreaseChange/Increaseinput.vue"; // 基础新增的新增输入框 
import Increasedialog from "@/components/Input/IncreaseChange/Increasedialog.vue"; // 基础新增的新增弹框框
import TableInput from "@/components/Input/TableInput/TableInput.vue"; // 表单商品名字数据框
import MaSelect from "@/components/Input/MaSelect/MaSelect.vue"; // 可过滤，下拉框选择
import MaInputClass from "@/components/Input/MaInputClass/MaInputClass.vue"; // 分类选择，弹出树形图，可进行过滤
import ScanInput from "@/components/Input/ScanInput/ScanInput.vue"; // 扫码录入 组件

import MaOrderTable from "@/components/Table/MaOrderTable/MaOrderTable.vue"; //测试表格

// 表格类
import baseTable from "@/components/Table/baseTable/baseTable.vue"; //基础组件-银行账户弹出框表格
import TreeTable from "@/components/Table/TreeTable/TreeTable.vue"; //经手人表格
import Table from "@/components/Table/Table/Table.vue"; //单据表格
import GoodsTable from "@/components/Table/GoodsTable/GoodsTable.vue"; //商品选择表格
import EarlystageTable from '@/components/Table/EarlystageTable/EarlystageTable.vue'; // 活动表格
import Earlystage from '@/components/Table/Earlystage/Earlystage.vue'; // 活动表格 -嵌套表格
import BasicsTable from "@/components/Table/BasicsTable/BasicsTable.vue" // 基础信息表格 活动表格
import Warehousetable from "@/components/Table/Warehousetable/Warehousetable.vue" // 基础信息表格
import Check from "@/components/Table/Check/Check.vue" // 表格---待命名
import ClientTable from "@/components/Table/ClientTable/ClientTable.vue" // 职员表格
import Modifytable from "@/components/Table/Modifytable/Modifytable.vue"
import Subjecttable from "@/components/Table/Posttable/Posttable.vue" // 岗位权限表格
import selectable from "@/components/Table/selectable/selectable.vue" // 
import housetable from "@/components/Table/housetable/housetable.vue" // 
import ReadableTable from "@/components/Table/ReadableTable/ReadableTable.vue"; //只可读表格
import TableTion from "@/components/Table/TableTion/TableTion.vue" // 验收
import TableRead from "@/components/Table/TableRead/TableRead.vue"; //只可读订单表格
import TableOrder from "@/components/Table/TableOrder/TableOrder.vue"; //订单-表格
import BankTable from "@/components/Table/BankTable/BankTable.vue"; //资金-账户表格
import BankTableRead from "@/components/Table/BankTableRead/BankTableRead.vue"; //资金-账户表格只可读
import GoodsDetailTable from "@/components/Table/GoodsDetailTable/GoodsDetailTable.vue"; //资金-客户商品表格
import GoodsDetailTableRead from "@/components/Table/GoodsDetailTableRead/GoodsDetailTableRead.vue"; //资金-客户商品表格只可读
import AccruedTable from "@/components/Table/AccruedTable/AccruedTable.vue"; //资金-增加应收表格
import ProcessTable from "@/components/Table/ProcessTable/ProcessTable.vue"; //报表-业务草稿表格/经营历程
import InventoryTable from "@/components/Table/InventoryTable/InventoryTable.vue"; //报表-当前库存表格
import InventoryDetailTable from "@/components/Table/InventoryDetailTable/InventoryDetailTable.vue"; //报表-库存分布表格
import CostTable from "@/components/Table/CostTable/CostTable.vue"; //报表-库存汇总表格
import Dealings from "@/components/Table/Dealings/Dealings.vue"; //报表-往来对账报表
import StatisticTable from "@/components/Table/StatisticTable/StatisticTable.vue"; //报表-商品销售统计表格/商品采购统计表格
import PersonnelStaticTable from "@/components/Table/PersonnelStaticTable/PersonnelStaticTable.vue"; //报表-客户销售统计表格/客户采购统计表格
import FunctionTable from "@/components/Table/FunctionTable/FunctionTable.vue"; //功能表格
import CapitalTable from "@/components/Table/CapitalTable/CapitalTable.vue"; // 资金模块功能表格
import BasicTable from "@/components/Table/BasicTable/BasicTable.vue"; //新表格 基础模块
import treeinput from "@/components/Table/treeinput/treeinput.vue"; //设置-期初表格
import Subjects from "@/components/Table/tables/table.vue"; //设置-其他收入
import EnterReceipt from "@/components/Table/EnterReceipt/EnterReceipt.vue"; //仓库-表格

import MaReportTable from "@/components/Table/MaReportTable/MaReportTable.vue"; //报表-所有表格
import MaGooodsMultiUnitTable from "@/components/Table/MaGooodsMultiUnitTable/MaGooodsMultiUnitTable.vue"; //商品多单位表格

import MaPrintTable from "@/components/Table/MaPrintTable/MaPrintTable.vue"; //


 
// 其他公用类
import Tree from "@/components/Common/Tree/Tree.vue"; //公用-树形图
// import treedata from "@/components/Common/treedata/treedata.vue"; //树形图
import treehistory from "@/components/Common/treehistory/treehistory.vue"; //树形图
import popover from "@/components/Common/popover/popover.vue"; //文件上传
import Reason from "@/components/Common/Reason/Reason.vue"; //红冲原因
import laoding from '@/components/Common/laoding/index.vue'; // 加载页面
import ImportPopover from "@/components/Common/ImportPopover/ImportPopover.vue"; //导入
import loading from "@/components/Common/laoding/index.vue"; //加载
import echarts from "@/components/Common/echarts/echarts.vue"; //加载
import echarts_line from "@/components/Common/echarts/echartsline.vue"; //加载
import LineEchart from "@/components/Common/LineEchart/LineEchart.vue"; //echart条形图表


export default (Vue) => {

  Vue.component("Jurisdiction", Jurisdiction); //常用功能弹框
  Vue.component("HeadConfigDialog", HeadConfigDialog); //页面配置弹出框
  Vue.component("addAreaDalog", addAreaDalog); //新增地区弹出框
  Vue.component("addClerkDialog", addClerkDialog); //新增经手人弹出框
  Vue.component("addCustomDialog", addCustomDialog); //新增经手人弹出框
  Vue.component("addDalog", addDalog); //新增单位弹出框
  Vue.component("manyUnit", manyUnit); //多单位弹出框
  Vue.component("SearchBankDialog", SearchBankDialog); //银行账户列表弹出框
  Vue.component("SearchSubjectDialog", SearchSubjectDialog); //科目弹出框

  Vue.component("searchClerkDialog", searchClerkDialog); //单位、仓库、经手人列表弹出框
  Vue.component("ClassificationDialog", ClassificationDialog); //分类弹出框
  Vue.component("TableConfigDialog", TableConfigDialog); //单据表格配置弹出框
  Vue.component("SearchGoodsDialog", SearchGoodsDialog); //单据表格商品选择弹出框
  Vue.component("SearchPriceDialog", SearchPriceDialog); //单据表格价格选择弹出框
  Vue.component("Customerdialog", Customerdialog); //基础信息 选择客户
  Vue.component("AddMember", AddMember); //基础信息 选择职员
  Vue.component("regions", regions); //基础信息 选择地区
  Vue.component("treebox", treebox); //基础信息 选择地区
  Vue.component("AddStorehouse", AddStorehouse); //基础信息 选择仓库
  Vue.component("Warehouse", Warehouse); //基础信息 选择仓库
  Vue.component("authority", authority); //岗位权限
  Vue.component("Choosehandler", Choosehandler); //基础信息 选择经手人
  Vue.component("Customer", Customer); // 选择客户弹框---待命名
  Vue.component("department", department); // 选择客户弹框---待命名 
  Vue.component("InvenTory", InvenTory); // 盘点单初始化
  Vue.component("power", power); // 岗位权限弹框 
  Vue.component("Searchcontent", Searchcontent); // 基础信息 选择往来单位 
  Vue.component("Subject", Subject); // 选择科目 
  Vue.component("ObtainOrder", ObtainOrder); // 调订单弹出框 
  Vue.component("ChoiceDialog", ChoiceDialog); // 选择框   
  Vue.component("SubjectsDialog", SubjectsDialog); // 增加应收表格-科目弹出框 
  Vue.component("HeaderElastic", HeaderElastic); // 表头配置 

  Vue.component("Searchpop", Searchpop); // 弹出选择框 
  Vue.component("MaTreeSelect", MaTreeSelect); // 弹出框选择树节点分类

  Vue.component("SubjectTables", SubjectTables); // 科目弹出选择框   
  Vue.component("UnitPrice", UnitPrice); // 单价弹出选择框
  Vue.component("GoodsTables", GoodsTables); //  商品弹出选择框      
  Vue.component("IncreaseChange", IncreaseChange); //  基础信息增改弹框    
  Vue.component("CompanyDialog", CompanyDialog); //  单位选择弹框     
  Vue.component("SerialTable", SerialTable); //  数量选择弹框     
  Vue.component("Multiple", Multiple); //  数量  多单位  
  Vue.component("MultipleRiod", MultipleRiod); // 期初  数量  多单位  
  Vue.component("AddBatchDialog", AddBatchDialog); //  期初批次录入
  Vue.component("coloursequence", coloursequence); //  期初序列号录入


  Vue.component("SelectInput", SelectInput); //选择、添加输入框
  Vue.component("SelectInputMultiple", SelectInputMultiple); //报表--多选input框
  Vue.component("InputSearch", InputSearch); //只选择输入框
  Vue.component("SelectOne", SelectOne); //下拉输入框
  Vue.component("InputTwo", InputTwo); //日期选择框
  Vue.component("InputThree", InputThree); //只输入框
  Vue.component("InputSelect", InputSelect); //报表--下拉框
  Vue.component("InputReadOne", InputReadOne); //只可读输入框
  Vue.component("InputRead", InputRead); //单据底部只可读输入框
  Vue.component("InputOne", InputOne); //基础信息--输入框
  Vue.component("lowerinput", lowerinput); // 企业信息
  Vue.component("baseTable", baseTable); // 基础组件-银行账户弹出框表格
  Vue.component("seleck", seleck); //设置--日志下拉框   
  Vue.component("elasticinput", elasticinput); //设置--现金银行期初条件查询   
  Vue.component("MaInput", MaInput); //可选择输入框
  Vue.component("MaInuptTwo", MaInuptTwo); //日期输入框 
  Vue.component("MaInputThree", MaInputThree); //只可输入的框  
  Vue.component("Increaseinput", Increaseinput); //基础新增的新增输入框
  Vue.component("Increasedialog", Increasedialog); //基础新增的新增弹框框  
  Vue.component("IncreaseDialogtable", IncreaseDialogtable); //基础新增的分类弹框 
  Vue.component("batchDialog", batchDialog); //批次情况  选择批次
  Vue.component("TableInput", TableInput); //表单商品名字数据框
  Vue.component("grouping", grouping); //分组权限


  Vue.component("MaSelect", MaSelect); // 科目下拉  
  Vue.component("MaInputClass", MaInputClass); // 分类选择，弹出树形图，可进行过滤
  Vue.component("ScanInput", ScanInput); // 扫码录入  


  Vue.component("MaOrderTable", MaOrderTable); // 报表-客户销售统计表格/客户采购统计表格
  Vue.component("MaPrintTable", MaPrintTable); // 



  Vue.component("TreeTable", TreeTable); //经手人表格
  Vue.component("Table", Table); //单据订单表格
  Vue.component("GoodsTable", GoodsTable); //商品选择表格
  Vue.component("EarlystageTable", EarlystageTable); //活动表格
  Vue.component("Earlystage", Earlystage); //活动表格 -嵌套表格
  Vue.component("BasicsTable", BasicsTable); //基础信息表格 活动表格 
  Vue.component("Warehousetable", Warehousetable); //基础信息表格 
  Vue.component("Check", Check); //基础信息表格   
  Vue.component("ClientTable", ClientTable); //职员表格   
  Vue.component("Modifytable", Modifytable);
  Vue.component("Subjecttable", Subjecttable); //岗位权限表格
  Vue.component("selectable", selectable); // 
  Vue.component("housetable", housetable); // housetable 
  Vue.component("TableTion", TableTion); // 验收 
  Vue.component("TableRead", TableRead); // 只可读订单表格 
  Vue.component("TableOrder", TableOrder); // 订单-表格 

  Vue.component("BankTable", BankTable); // 资金-账户表格
  Vue.component("BankTableRead", BankTableRead); // 资金-账户表格只可读
  Vue.component("GoodsDetailTable", GoodsDetailTable); // 资金-客户商品表格
  Vue.component("GoodsDetailTableRead", GoodsDetailTableRead); // 资金-客户商品表格只可读 
  Vue.component("ProcessTable", ProcessTable); // 报表-业务草稿表格
  Vue.component("InventoryTable", InventoryTable); // 报表-当前库存表格
  Vue.component("InventoryDetailTable", InventoryDetailTable); // 报表-库存分布表格
  Vue.component("CostTable", CostTable); // 报表-库存分布表格 
  Vue.component("StatisticTable", StatisticTable); // 报表-商品销售统计表格/商品采购统计表格  
  Vue.component("PersonnelStaticTable", PersonnelStaticTable); // 报表-客户销售统计表格/客户采购统计表格
  Vue.component("FunctionTable", FunctionTable); // 功能表格  
  Vue.component("CapitalTable", CapitalTable); // 资金模块功能表格
  Vue.component("ReadableTable", ReadableTable); // 只可读表格

  Vue.component("MaReportTable", MaReportTable); // 报表-所有表格
  Vue.component("MaGooodsMultiUnitTable", MaGooodsMultiUnitTable); // 商品多单位表格

  Vue.component("MaOrderTable", MaOrderTable); // 报表-客户销售统计表格/客户采购统计表格
  Vue.component("MaPrintTable", MaPrintTable); // 


  Vue.component("BasicTable", BasicTable); //新表格 基础模块

  Vue.component("treeinput", treeinput); // 设置-期初表格 
  Vue.component("Subjects", Subjects); // 设置-其他收入  
  Vue.component("EnterReceipt", EnterReceipt); // 仓库-表格
  Vue.component("AccruedTable", AccruedTable); // 资金-增加应收表格
  Vue.component("Dealings", Dealings); // 报表-往来对账报表

  Vue.component("Tree", Tree); //树形图组件
  Vue.component("treehistory", treehistory); //树形图组件
  Vue.component("popover", popover); //文件上传
  Vue.component("Reason", Reason); //红冲原因
  Vue.component("laoding", laoding); //加载页面·
  Vue.component("ImportPopover", ImportPopover); //导入
  Vue.component("loading", loading); //加载 
  Vue.component("echarts", echarts); //boss报表  饼图
  Vue.component("echartsLine", echarts_line); //首页 金额统计  线图
  Vue.component("LineEchart", LineEchart); //echart条形图表

}


// import InputTwo from "@/components/base/InputTwo/InputTwo.vue";//选择日期
// import InputThree from "@/components/base/InputThree/InputThree.vue";//只可输入组件
// import InputRead from "@/components/base/InputRead/InputRead.vue";//只可读无框组件
// import InputReadOne from "@/components/base/InputReadOne/InputReadOne.vue";//只可读有框组件
// import InputSearch from "@/components/base/InputSearch/InputSearch.vue";//只可收索的组件
// import SelectInput from '@/components/base/SelectInput/SelectInput.vue'//可选择可新增弹出框
// import SelectInputMultiple from "@/components/base/SelectInputMultiple/SelectInputMultiple.vue";//多选择商品
// import InputSelect from '@/components/base/InputSelect/InputSelect.vue'//下拉选择框
// import HeadConfigDialog from "@/components/Dialog/HeadConfigDialog/HeadConfigDialog.vue";//页面配置
// import Table from "@/components/base/Table/Table.vue";//订单表格
// import TableRead from "@/components/base/TableRead/TableRead.vue";//只可读订单表格
// import Tree from "@/components/base/Tree/Tree.vue";//属性图控件
// import TreeTable from "@/components/base/TreeTable/TreeTable.vue";//树状图table表组件
// import baseTable from "@/components/base/baseTable/baseTable.vue";//树状图table表组件
// import StatisticTable from "@/components/base/StatisticTable/StatisticTable.vue";//统计表格
// import GoodsDetailTable from "@/components/base/GoodsDetailTable/GoodsDetailTable.vue";//商品明细表格
// import GoodsDetailTableRead from "@/components/base/GoodsDetailTableRead/GoodsDetailTableRead.vue";//只可读商品明细表格

// import ProcessTable from "@/components/base/ProcessTable/ProcessTable.vue";//经营历程表格
// import InventoryTable from "@/components/base/InventoryTable/InventoryTable.vue";//当前库存表格
// import InventoryDetailTable from "@/components/base/InventoryDetailTable/InventoryDetailTable.vue";//库存分布表格
// import PersonnelStaticTable from "@/components/base/PersonnelStaticTable/PersonnelStaticTable.vue";//客户、供应商销售/采购统计
// import BankTable from "@/components/base/BankTable/BankTable.vue";//资金收付款银行表格
// import BankTableRead from "@/components/base/BankTableRead/BankTableRead.vue";//只可读资金收付款银行表格

// import AccruedTable from "@/components/base/AccruedTable/AccruedTable.vue";//资金应收应付表格

// import SaleOrder from "@/components/Page/SaleOrder/SaleOrder.vue";//页面，测试
// // 弹出框
// import SubjectsDialog from "@/components/Dialog/SubjectsDialog/SubjectsDialog.vue";//资金应收应付弹出框
// import Reason from "@/components/Receipt/Reason/Reason.vue";//红冲原因弹出框

// export default (Vue)=>{
//     Vue.component("InputTwo",InputTwo);
//     Vue.component("InputThree",InputThree);
//     Vue.component("InputRead",InputRead);
//     Vue.component("InputReadOne",InputReadOne);
//     Vue.component("InputSearch",InputSearch);
//     Vue.component("SelectInput",SelectInput);
//     Vue.component("HeadConfigDialog",HeadConfigDialog);
//     Vue.component("Table",Table);
//     Vue.component("Tree",Tree);
//     Vue.component("TreeTable",TreeTable);
//     Vue.component("baseTable",baseTable);
//     Vue.component("InputSelect",InputSelect);
//     Vue.component("StatisticTable",StatisticTable);
//     Vue.component("SelectInputMultiple",SelectInputMultiple);
//     Vue.component("GoodsDetailTable",GoodsDetailTable);
//     Vue.component("GoodsDetailTableRead",GoodsDetailTableRead);
//     Vue.component("ProcessTable",ProcessTable);
//     Vue.component("TableRead",TableRead);
//     Vue.component("InventoryTable",InventoryTable);
//     Vue.component("InventoryDetailTable",InventoryDetailTable);
//     Vue.component("PersonnelStaticTable",PersonnelStaticTable);
//     Vue.component("BankTable",BankTable);
//     Vue.component("BankTableRead",BankTableRead);
//     Vue.component("AccruedTable",AccruedTable);
//     Vue.component("SubjectsDialog",SubjectsDialog);

//     Vue.component("SaleOrder",SaleOrder);
//     Vue.component("Reason",Reason);

// }



// WEBPACK FOOTER //
// ./src/utils/install.js